import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { REQUEST_STATUS } from "@/modules/constants/REQUEST_STATUS";
import { useAppSelector } from "@/store/store";
import { ROUTES } from "../App/routePaths";
import { selectEstateListStatus } from "../modules/estate/estateList/estateListSlice";
import Container from "./Common/Container";
import PageLoader from "./Common/PageLoader";
import MainNavigation from "./Navigation/MainNavigation";

const ProtectedRoute = ({ children }) => {
  const sessionToken = useAppSelector((state) => state.sessionToken);
  const estateListStatus = useAppSelector(selectEstateListStatus);
  const location = useLocation();

  const appIsLoading = estateListStatus === REQUEST_STATUS.LOADING;

  if (!sessionToken) {
    return (
      <Navigate
        to={ROUTES.SIGN_IN}
        state={{ returnTo: location.pathname }}
        replace
      />
    );
  }

  if (appIsLoading) {
    return <PageLoader />;
  }

  if (estateListStatus === REQUEST_STATUS.FAILED) {
    return <div>Error loading estates. Please try again later.</div>;
  }

  return (
    <React.Fragment>
      <Container>{children}</Container>
      <MainNavigation />
    </React.Fragment>
  );
};

export default ProtectedRoute;
